// extracted by mini-css-extract-plugin
export default {"wrapper__outer":"apps_wrapper__outer__vayFP","wrapper__content":"apps_wrapper__content__U19e7"};